import { FormPropertyType, FuelType, HeatingCalculationMethod, IsolationType, ProjectPropertyType } from '@/helper/Types'
import { ProcessFunctions } from '@/helper/ProcessFunctions'
import { AbstractCalculatedLoad } from '@/services/models/AbstractCalculatedLoad'
import { HeatingBuildingInfo } from '@/services/models/HeatingBuildingInfo.ts'
import { HeatingConsumptionInfo } from '@/services/models/HeatingConsumptionInfo.ts'

export class CalculatedHeatingLoadRequest extends AbstractCalculatedLoad {

  public heatingBuildingInfo?: HeatingBuildingInfo
  public heatingConsumptionInfo?: HeatingConsumptionInfo

  constructor(props: ProjectPropertyType, formData: Partial<FormPropertyType>) {
    super(props, formData)

    const isolation = (ProcessFunctions.getRevertFunction(props.isolation.formRevertType)(formData.isolation || false) || []) as IsolationType[]

    if (formData.heatingCalculationMethod === HeatingCalculationMethod.THERMAL_ENVELOPE) {
      this.heatingBuildingInfo = {
        isolatedFloor: isolation.includes(IsolationType.FLOOR),
        isolatedWalls: isolation.includes(IsolationType.WALLS),
        isolatedRoof: isolation.includes(IsolationType.ROOF),
        indoorTemperature: this.getPropsRevertValue(props, formData, 'heatingIndoorTemperature') as number | undefined,
        ventilationType: this.getPropsRevertValue(props, formData, 'heatingVentilationType') as string | undefined,
        windowType: this.getPropsRevertValue(props, formData, 'windowType') as string | undefined,
        adjoinedBuildingSides: this.getPropsRevertValue(props, formData, 'adjoinedBuildingSides') as number | undefined
      }
    }

    if (formData.heatingCalculationMethod === HeatingCalculationMethod.CONSUMPTION) {
      this.heatingConsumptionInfo = {
        previousFuelType: this.getPropsRevertValue(props, formData, 'previousFuelType') as FuelType | undefined,
        operatingHours: this.getPropsRevertValue(props, formData, 'operatingHours') as number | undefined,
        annualConsumption: this.getPropsRevertValue(props, formData, 'annualConsumption') as number | undefined,
        annualConsumptionUnit: this.getPropsRevertValue(props, formData, 'annualConsumptionUnit') as string | undefined
      }
    }
  }

  public validate(): boolean {
    const heatingBuildingInfoValid = !!(
      this.heatingBuildingInfo?.windowType
      && this.heatingBuildingInfo?.adjoinedBuildingSides !== undefined
      && this.heatingBuildingInfo?.ventilationType
      && this.heatingBuildingInfo?.indoorTemperature
    )
    console.debug('heatingBuildingInfoValid', heatingBuildingInfoValid)

    const heatingConsumptionInfoValid = !!(
      this.heatingConsumptionInfo?.previousFuelType
      && this.heatingConsumptionInfo?.operatingHours
      && this.heatingConsumptionInfo?.annualConsumption
      && this.heatingConsumptionInfo?.annualConsumptionUnit
    )
    console.debug('heatingConsumptionInfoValid', heatingConsumptionInfoValid)

    return (heatingBuildingInfoValid && super.validate()) || heatingConsumptionInfoValid
  }
}
